import React from 'react';
import ReactApexChart from 'react-apexcharts';
import NoDataFound from '../../NoDataFound/NoDataFound';
import useThemeTextColor from '../../../../../utils/useThemeTextColor';

// Helper function to format labels
const formatLabel = (label) => {
  return label
    .split(' ')
    .map(word => {
      const lower = word.toLowerCase();
      if (['b2b', 'b2c', 'api', 'crm', 'erp', 'na', 'cod', 'Na', 'Cod'].includes(lower)) {
        return lower.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

const PaymentDistributionChart = ({ chartData }) => {
  const textColor = useThemeTextColor();

  if (
    !Array.isArray(chartData) ||
    chartData.length === 0 ||
    chartData.every(item => Number(item.value) === 0)
  ) {
    return <NoDataFound height={300} />;
  }

  const labels = chartData.map(item => formatLabel(item.name));
  const series = chartData.map(item => Number(item.value));
  const counts = chartData.map(item => item.count);

  const total = series.reduce((sum, val) => sum + val, 0);
  const options = {
    chart: {
      type: 'donut',
      height: 300,
    },
    labels,
    colors: ['#007bff', '#ffa726', '#00c853', '#ff5252', '#7e57c2'],
    legend: {
      position: 'bottom',
      labels: {
        colors: textColor,
        useSeriesColors: false,
      },
      formatter: function (val, opts) {
        const value = opts.w.globals.series[opts.seriesIndex];
        const percent = ((value / total) * 100).toFixed(1);
        const count = counts[opts.seriesIndex] ?? 0;
        return `${val}`;
        // return `${val}: ${value}% (${count})`;
      },
    },
    plotOptions: {
      pie: {
        donut: {
          // size: '50%',
        },
      }},
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
        // val here is already percentage
        // return `${val.toFixed(1)}%`;
      },
      style: {
        fontSize: window.innerWidth < 768 ? '10px' : '12px',
        fontWeight: 'bold',
        colors: ['#000'],
      },
      dropShadow: {
        enabled: false,
      },
    },
    tooltip: {
      y: {
        formatter: function (value, opts) {
          const percent = ((value / total) * 100).toFixed(1);
          const label = labels[opts.seriesIndex] ?? "";
          const count = counts[opts.seriesIndex] ?? 0;
          return `${value}% (${count})`;
        },
      },
    },
    stroke: {
      colors: ['#fff'],
      width: 2,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 300,
          },
          legend: {
            position: 'bottom',
          },
          dataLabels: {
            style: {
              fontSize: '8px',
            }
          }
        },
      },
    ],
  };

  return (
    <div style={{ width: '100%', minHeight: '250px' }}>
      <ReactApexChart options={options} series={series} type="donut" height={300} />
    </div>
  );
};

export default PaymentDistributionChart;
